var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[(_vm.currentBreakpoint === 'desktop')?_c('AppHeaderDesktop'):_vm._e(),(_vm.currentBreakpoint !== 'desktop')?_c('AppHeaderMobile'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }